import { SupplierBM } from '../types/BusinessModel/SupplierBM';
import { Supplier } from '../types/ViewModel/Supplier';

export const createSupplier = (supplier: SupplierBM): Supplier => {
    return {
        supplierId: supplier.supplierId,
        supplierName: supplier.name,
    };
};

export const createSupplierList = (suppliers: SupplierBM[]) => suppliers.map((supplier) => createSupplier(supplier));
